import ClassicUpgrade from "../../../model/upgrade/classic/ClassicUpgrade";
import ClassicUpgradeCollection from "../../../model/upgrade/classic/ClassicUpgradeCollection";
import ClassicUpgradeCollectionView from "./ClassicUpgradeCollectionView";
import ClassicUpgradeView from "./ClassicUpgradeView";

export default class GoldUpgradeCollectionView extends ClassicUpgradeCollectionView {
    /**
     * @param {string} parentId
     * @param {string} elementId 
     * @param {ClassicUpgradeCollection} upgradeCollection
     */
    constructor(parentId, elementId, upgradeCollection) {
        super(parentId, elementId, upgradeCollection);
    }

    /**
     * @override
     * @param {ClassicUpgrade} upgrade 
     * @returns {ClassicUpgradeView}
     */
    createUpgradeView(upgrade) {
        return new ClassicUpgradeView(this.elementId, this.elementId + '_' + this.getNextId(), upgrade, true);
    }
}